const months = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sep',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec'
};
const getDaysRemaining = (formattedExpirationDate, oneDay) => Math.round((formattedExpirationDate.getTime() - new Date().getTime()) / oneDay);
const getDaysFromPurchaseToExpiration = (formattedExpirationDate, formattedPurchaseDate, oneDay) => {
    const expirationDateString = formattedExpirationDate.toLocaleDateString('en-us');
    const purchaseDateAmountString = formattedPurchaseDate.toLocaleDateString('en-us');
    return Math.round((new Date(expirationDateString).getTime() -
        new Date(purchaseDateAmountString).getTime()) /
        oneDay);
};
const isPositiveNumber = (item) => Number(item) >= 0;
const renderRemainingDaysChart = (chartsData) => {
    const { daysRemaining, daysRemainingPercentage } = chartsData;
    return [daysRemaining, daysRemainingPercentage]
        .map(isPositiveNumber)
        .every(Boolean);
};
// this function is for generating mock data. Should be removed when integration with API it's done.
// eslint-disable-next-line max-lines-per-function
export const getChartData = (promotion) => {
    const { purchaseAmount, remainingBalance, expirationDate, purchaseDate, totalAmountPaid } = promotion;
    const formattedPurchaseAmount = Number(purchaseAmount);
    const amountPaidPercentage = (+totalAmountPaid / formattedPurchaseAmount) * 100;
    const chartsData = {
        amountPaidPercentage,
        daysRemaining: 0,
        daysRemainingPercentage: 0,
        formattedAmountPaid: '0',
        isPromotionPastPeriod: false,
        promoHasBeenPaid: false,
        remainingBalance,
        remainingDaysInitialValue: '',
        remainingDaysMaxValue: '',
        shouldRenderAmountPaidChart: true,
        shouldRenderRemainingDaysChart: false,
        totalAmountPaid
    };
    try {
        const oneDay = 1000 * 60 * 60 * 24;
        const formattedExpirationDate = expirationDate && new Date(expirationDate.replace(/-/g, '/'));
        const formattedPurchaseDate = purchaseDate && new Date(purchaseDate.replace(/-/g, '/'));
        if (formattedExpirationDate instanceof Date &&
            formattedPurchaseDate instanceof Date) {
            chartsData.daysRemaining = getDaysRemaining(formattedExpirationDate, oneDay);
            const daysFromPurchaseToExpiration = getDaysFromPurchaseToExpiration(formattedExpirationDate, formattedPurchaseDate, oneDay);
            const daysPast = daysFromPurchaseToExpiration - chartsData.daysRemaining;
            chartsData.daysRemainingPercentage = Number(Math.round((daysPast / daysFromPurchaseToExpiration) * 100));
            chartsData.shouldRenderRemainingDaysChart =
                renderRemainingDaysChart(chartsData);
            const initialMonth = formattedPurchaseDate.getMonth();
            const monthName = months[initialMonth];
            const initialDay = formattedPurchaseDate.getDate();
            chartsData.remainingDaysInitialValue = `${initialDay} ${monthName}`;
            const maxMonth = formattedExpirationDate.getMonth();
            const maxMonthName = months[maxMonth];
            const maxInitialDay = formattedExpirationDate.getDate();
            chartsData.remainingDaysMaxValue = `${maxInitialDay} ${maxMonthName}`;
        }
        chartsData.formattedAmountPaid = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(formattedPurchaseAmount);
        chartsData.isPromotionPastPeriod =
            !!expirationDate &&
                chartsData.daysRemaining < 0 &&
                +totalAmountPaid < formattedPurchaseAmount;
        chartsData.promoHasBeenPaid =
            !chartsData.isPromotionPastPeriod &&
                Number(totalAmountPaid) === Number(purchaseAmount);
        return chartsData;
    }
    catch (error) {
        return chartsData;
    }
};
//# sourceMappingURL=get-promos-chart-data.js.map